var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2064B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,9.7c-0.2-1-0.6-1.9-1.2-2.8l1.1-2.3l-1.5-1.5L16,4.2c-0.9-0.5-1.7-0.9-2.7-1.1l-0.8-2.4h-2.1L9.6,3.1 c-1,0.2-1.8,0.6-2.7,1.2L4.6,3.2L3.1,4.6l1.1,2.3C3.7,7.7,3.4,8.6,3.1,9.6l-2.4,0.9v2.1l2.4,0.9c0.2,1,0.6,1.9,1.1,2.7l-1.1,2.3 l1.5,1.5l2.3-1.1c0.9,0.5,1.7,1,2.7,1.2l0.9,2.3h2.1l0.9-2.4c0.3-0.1,0.8-0.2,1.1-0.3l-1.7-1.7c-4.1,0.8-7.7-2.3-7.7-6.3 C5.1,8,8,5.1,11.5,5.1c4,0,7,3.5,6.3,7.3l1.8,1.8c0.1-0.3,0.2-0.5,0.2-0.9l2.4-0.8v-2.1L19.9,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,19.4l-6.3-6.3c1.5-3.3-1.6-6.9-5-5.9l1.9,1.9c0.9,0.9,0.9,2.3,0,3c-0.8,0.9-2.3,0.9-3,0l-1.9-1.8 c-1,3,2.1,6.4,5.7,5l6.3,6.3c0.6,0.6,1.6,0.6,2.3,0C22.3,21.1,22.3,20.1,21.8,19.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipments);
export default __webpack_public_path__ + "static/media/equipments.cad71b498397a6bf14af22a1f490e6d9.svg";
export { ForwardRef as ReactComponent };